import React, { useRef, useState, useEffect } from "react";
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import styles from "./MultiLevelSelect.module.scss";

const MultiLevelSelect = ({
  label = "",
  name,
  value = "",
  onChange,
  options,
  placeholder = "Select Category",
}) => {
  let [isOpen, setIsOpen] = useState(false);

  let categoryRef = useRef(null);

  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (categoryRef && !categoryRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const onSelect = async (id, category) => {
    await setIsOpen(false);
    onChange({
      _id: id,
      categoryName: category,
    });
  };

  return (
    <>
      <label className={styles.category_dropdown_label}>{label}</label>
      <div
        className={styles.category_dropdown}
        tabIndex="0"
        onClick={() => setIsOpen(true)}
        ref={categoryRef}
      >
        <div className={styles.category_dropdown_value}>
          <span>{value === "" ? placeholder : value}</span>
          <i
            className="icon-drop-down"
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          ></i>
        </div>
        {isOpen && (
          <div className={styles.category_dropdown_options}>
            {options.map((list, index) => {
              return (
                <div key={index} className={styles.main_category}>
                  <div onClick={() => onSelect(list._id, list.categoryName)}>
                    <span style={{ cursor: "pointer" }}>
                      {list.categoryName}
                    </span>
                  </div>
                  <UncontrolledDropdown direction="right">
                    <DropdownToggle tag="span" data-toggle="dropdown">
                      <i
                        className="icon-next-arrow"
                        style={{ display: "inline-block", marginTop: "8px" }}
                        onClick={() => setIsOpen(true)}
                      ></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      {list.subCategories.map((item, ind) => {
                        return (
                          <DropdownItem
                            key={ind}
                            onClick={() =>
                              onSelect(item._id, item.categoryName)
                            }
                          >
                            <div className="dropdown-items">
                              <span>{item.categoryName}</span>
                            </div>
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default MultiLevelSelect;
